import { ShoppingCartAnonSessionRequest } from "../../domain/ShoppingCartSlice/ShoppingCartAnonSessionRequest";
import { ShoppingCartGet } from "../../domain/ShoppingCartSlice/ShoppingCartGet";
import { ShoppingCartInsert } from "../../domain/ShoppingCartSlice/ShoppingCartInsert";
import ApiWrapper from "../Common/ApiWrapper";

export class ShoppingCartRepository 
    extends ApiWrapper<void, ShoppingCartInsert, void, ShoppingCartAnonSessionRequest> {
    constructor() {
        super('shopping-carts/');
    }

    async fetchShoppingCart(cart: ShoppingCartAnonSessionRequest): Promise<ShoppingCartGet | null> {
        return await this.getOneCustom({params: cart });
    }
}
